import React, { useEffect, useState } from "react";
import "./HomeworkDeails.css"
import Toast from "../../UI/Toast/Toast";
import { Breadcrumb, Col, Row, Form, Button } from 'react-bootstrap';
import Card from '../../UI/Card/Card';
import Input from "../../UI/Input/Input";
import { ChevronRight } from '@mui/icons-material';
import userService from "../../app/services/user.service";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from '../../UI/loader/loader';
import { Link } from "react-router-dom";

export const HomeworkDetails = () => {

   
    const [homeworkDetails, setHomeworkDetails] = useState({});
    const [students, setStudents] = useState([]);
    const [loader, setloader] = useState(true);

    const navigate = useNavigate();

    const location = useLocation();
    const { schedule_id } = location.state || {};
    const schedule=schedule_id;

    console.log(schedule_id);

    useEffect(() => {

        getHomeworkDetails();

    }, []);

    



    const getHomeworkDetails = () => {

        userService.homeworkDetails(schedule_id)
            .then(res => {
                setHomeworkDetails(res.data.data);
                setStudents(res.data.submit_user);
                console.log("Data", res.data);
                setloader(false);

            })
            .catch(err => {
                console.error('Failed to fetch homework modules', err);
            });
    }


    console.log(homeworkDetails);
    console.log(students)

    const handleViewQuestion = () => {

        navigate("./viewQuestion", { state: { schedule_id:schedule } });
    }

    return (
        <>
            <Toast />
            <div className="d-flex page-head justify-content-between align-items-center">
                <div>
                    <h4> Homework Details</h4>
                    <Breadcrumb>
                    
                        <Breadcrumb.Item active>Homework Details</Breadcrumb.Item>
                        {/* <Breadcrumb.Item active>Completed</Breadcrumb.Item>
            <Breadcrumb.Item active>Questions</Breadcrumb.Item> */}
                    </Breadcrumb>
                </div>
            </div>

            {loader && <Loader />}

            <div>

                <Card className="homework_details">
                    <Row>
                        <Col lg={6} sm={12} className="my-1">
                            <Form.Label htmlFor="paper_id">Assigned Date</Form.Label>
                            <Input

                                type="text"
                                value={homeworkDetails.assign_date}

                                disabled
                            />
                        </Col>

                        <Col lg={6} sm={12} className="my-1">
                            <Form.Label htmlFor="paper_id">Submission Date:</Form.Label>
                            <Input
                                required
                                type="text"

                                value={homeworkDetails.submisstion_date}
                                disabled
                            />
                        </Col>
                        <Col lg={6} sm={12} className="my-1">
                            <Form.Label htmlFor="paper_id">No of students assigned</Form.Label>
                            <Input
                                required
                                type="text"
                                value={homeworkDetails.total_student}
                                disabled
                            />
                        </Col>
                        <Col lg={6} sm={12} className="my-1">
                            <Form.Label htmlFor="paper_id">% students submitted</Form.Label>
                            <Input
                                required
                                type="text"
                                value={homeworkDetails.total_submit}
                                disabled
                            />
                        </Col>
                        <Col lg={6} sm={12} className="my-1">
                            <Form.Label htmlFor="paper_id">% students not submitted</Form.Label>
                            <Input

                                type="text"
                                value={homeworkDetails.total_not_submit}
                                disabled
                            />
                        </Col>
                        <Col lg={6} sm={12} className="my-1">
                            <Form.Label htmlFor="paper_id">% students Late submitted</Form.Label>
                            <Input

                                type="text"
                                value={homeworkDetails.later_submit}
                                disabled
                            />
                        </Col>

                    </Row>          
                </Card>
            </div>

            <div className="preview-card1 preview-card">
                <div>
                    <span className="preview-text">View Questions</span>

                </div>
                <Link
                    to="./ViewQuestion"
                    state={{ schedule_id: schedule_id }}
                >
                    <ChevronRight className="preview-icon" />
                </Link>
            </div>

            <div className="preview-container1">
                <div className="total_question">
                    <p>Attempted Students Details</p>
                </div>
                {students?.map((student, index) => (

                    <div className="preview-card">
                        <div>
                            <span className="preview-text"><b>{student.name}</b></span>
                            <p className="submission-date">Submitted On : {student.submit_on.slice(0, 11)}</p>
                        </div>
                        <div className="view-details">
                            <Link
                                to="./studentDetails"
                                state={{ homework_id: student.homework_id, user_id: student.user_id }}
                            >
                                <button>
                                    <span>View Details </span>
                                    <ChevronRight className="preview-icon" />
                                </button>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>

        </>
    )
}